.btn-delete-connection{margin-top:-6px;margin-right:-11px}
/*# sourceMappingURL=network-form.component-UFSEYA76.css.map */
